import { render, staticRenderFns } from "./SingleManualMatching.vue?vue&type=template&id=0a65ff35&"
import script from "./SingleManualMatching.vue?vue&type=script&lang=js&"
export * from "./SingleManualMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports